// Lightweight client for the Bloom DPP JWT API (brand & user logins).
// Separate from the legacy Cognito AuthProvider used by the jewellery flow.
export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "http://localhost:5000";
export const DPP_BASE_URL = process.env.REACT_APP_DPP_BASE_URL || "http://localhost:3000";

// Format any date/datetime for display as "28th July, 2025" — day ordinal, full
// month, year; time is dropped. Date-only strings are parsed without a timezone
// shift so the day never moves. Returns '' for empty and the raw value if unparseable.
export const formatDate = (value) => {
    if (!value) return '';
    const iso = String(value).match(/^(\d{4})-(\d{2})-(\d{2})/);
    const d = iso ? new Date(Number(iso[1]), Number(iso[2]) - 1, Number(iso[3])) : new Date(value);
    if (isNaN(d.getTime())) return String(value);
    const day = d.getDate();
    const k = day % 100, j = day % 10;
    const suffix = (k >= 11 && k <= 13) ? 'th' : j === 1 ? 'st' : j === 2 ? 'nd' : j === 3 ? 'rd' : 'th';
    return `${day}${suffix} ${d.toLocaleString('en-US', { month: 'long' })}, ${d.getFullYear()}`;
};

// Tokens are kept per role so a brand and a user can be logged in independently.
export const getToken = (role) => localStorage.getItem(`bloom_${role}_token`);
export const setToken = (role, token) => localStorage.setItem(`bloom_${role}_token`, token);
export const clearToken = (role) => localStorage.removeItem(`bloom_${role}_token`);

export async function apiFetch(path, { method = "GET", token, body, isForm = false } = {}) {
    const headers = {};
    if (token) headers["Authorization"] = `Bearer ${token}`;
    if (body && !isForm) headers["Content-Type"] = "application/json";

    const res = await fetch(`${API_BASE_URL}${path}`, {
        method,
        headers,
        body: isForm ? body : body ? JSON.stringify(body) : undefined,
    });

    const data = await res.json().catch(() => ({}));
    if (!res.ok) throw new Error(data.error || `Request failed (${res.status})`);
    return data;
}
